<input [readOnly]="disabled || null" [disabled]="disabled" type="date" placeholder="dd/mm/aaaa" [value]="value" (change)="onChangeValue($event)" [class.--is-placeholder]="placeholder" />
